import { CompoundFilterOptionsProps } from './CompoundFilterOptions.types';
import { useStyles } from './CompoundFilterOptions.styles';
import { CompoundFilterOption } from './components';
import { useCompoundFilterContext } from '../../hooks';
import { useRenderOptionProps } from './hooks';
import { Button } from '../../../buttons/Button';
import { RenderWhen } from '../../../RenderWhen';
import { resolveCompoundFilterStateModifiers } from '../../helpers';
import { Eraser } from '../../../icons';

export const CompoundFilterOptions = ({
  renderOptionPrefix = () => null,
  renderOptionSuffix = () => null,
}: CompoundFilterOptionsProps) => {
  const styles = useStyles();
  const { state, dispatch } = useCompoundFilterContext();
  const activeItemindex = state.findIndex((item) => item?.stateModifiers?.isActive === true);
  const renderOptionProps = useRenderOptionProps(activeItemindex);

  if (activeItemindex >= 0 && renderOptionProps !== null) {
    const options = state[activeItemindex].options;

    return (
      <div css={styles.root}>
        <div css={styles.options}>
          {renderOptionPrefix(renderOptionProps)}
          {options.map((option, optionIndex) => {
            const { isActive, isVisible, isRemovable } = resolveCompoundFilterStateModifiers(
              option.stateModifiers,
            );
            return (
              <RenderWhen key={option.id} condition={isVisible}>
                <CompoundFilterOption
                  isActive={isActive}
                  isRemovable={isRemovable}
                  label={option.label}
                  onClick={() => {
                    dispatch({
                      type: 'TOGGLE_OPTION',
                      payload: {
                        itemIndex: activeItemindex,
                        optionIndex,
                      },
                    });
                  }}
                  onRemove={() => {
                    dispatch({
                      type: 'REMOVE_OPTION',
                      payload: {
                        itemIndex: activeItemindex,
                        optionIndex,
                      },
                    });
                  }}
                />
              </RenderWhen>
            );
          })}

          <RenderWhen condition={options.length > 0}>
            <Button
              variant="transparent"
              className="flex !h-8 !w-8 items-center justify-center rounded-md bg-secondary-400 px-2 transition-colors hover:bg-bg-secondary active:bg-secondary-700 active:shadow-primary-inset"
              onClick={() => {
                dispatch({
                  type: 'CLEAR_OPTIONS',
                  payload: activeItemindex,
                });
              }}
            >
              <Eraser
                role="img"
                aria-label="Clear All"
                size="1.2rem"
                className="cursor-pointer stroke-primary-400"
              >
                <title>Clear All</title>
              </Eraser>
            </Button>
          </RenderWhen>
        </div>

        {renderOptionSuffix(renderOptionProps)}
      </div>
    );
  }

  return null;
};
